import React from 'react'
import './loader.scss'

function Loader() {
  return (
    <svg
      className="spinner"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        className="path-small"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        cx="10"
        cy="10"
        r="9"
      />
    </svg>
  )
}

export default Loader
